import React, { useMemo } from 'react';

import Button from '../../../button/button';
import Typography from '../../../typography/typography';

import './fitment-edit-steps.scss';

interface Crumb {
  description?: string;
  isActive: boolean;
  isClickable: boolean;
  isCompleted: boolean;
  label: string;
}

interface FitmentEditStepsProps {
  crumbs: Array<Crumb>;
  onCrumbSelected: (crumb) => void;
  selectedCrumb: string;
}

function FitmentEditSteps(props: FitmentEditStepsProps) {
  const { crumbs, onCrumbSelected, selectedCrumb } = props;

  const editableCrumbs = useMemo(() => {
    const selectedCrumbIndex = crumbs.findIndex(
      crumb => crumb.label === selectedCrumb
    );

    return crumbs.reduce((arr, crumb, idx) => {
      if (idx < selectedCrumbIndex && crumb.isCompleted && crumb.description) {
        arr.push(crumb);
      }

      return arr;
    }, [] as Array<Crumb>);
  }, [crumbs, selectedCrumb]);

  return (
    <div data-testid="fitment-edit-steps" styleName="container">
      {editableCrumbs.map(({ description, label }) => (
        <div key={label} styleName="step">
          <Typography weight="black">{description}</Typography>
          <Button onClick={() => onCrumbSelected(label)}>edit</Button>
        </div>
      ))}
    </div>
  );
}

export default FitmentEditSteps;
